// ----------------------------------------------------------------------------
// Product Form Web Component: iamSellingPlanInput <iam-selling-plan-input>
// Extends: iamFormElement
// ----------------------------------------------------------------------------
// The Selling Plan Input is responsible for handling the selling plan selection UI.
// ----------------------------------------------------------------------------
// Event Listeners:
// - `productForm:variant:changed` → Dynamically refreshes selling plans on variant change
// ----------------------------------------------------------------------------
// Gotchas:
// - Unknown support with Preorders, multiple selling plan groups, or plans with >1 option input
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import iamFormElement from 'scripts/classes/iamFormElement';
import { promoConfig, calculateDiscountedPrice, formatCentsToDollars } from '../promo-price-override/promo-price-override';

// Styles
import './_ordergroove-offer.scss';

// Additional Features
import './ordergroove-offer--show-frequency.js'; // Show frequency in the OrderGroove offer

class iamOrdergrooveOffer extends iamFormElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.ogOffer = this.querySelector('og-offer');
    this.sellingPlanInput = this.querySelector('[name="selling_plan"]');

    // Broadcast Selling Plan Changes
    if (this.sellingPlanInput) {
      var triggerChange = () => {
        iamotaEventHandler.trigger('productForm:sellingPlanInput:changed', {
          sellingPlan: this.sellingPlanInput.value
        }, {
          context: this.iamForm
        });
      };

      // Trigger on change
      this.sellingPlanInput.addEventListener('change', triggerChange);

      // Optional: trigger on input if you want more immediate feedback
      this.sellingPlanInput.addEventListener('input', triggerChange);
    }
    super.connectedCallback();
  }
  onFormInit() {
    iamotaEventHandler.subscribe('productForm:variant:changed', this.onVariantChange.bind(this), {
      context: this.iamForm,
      source: "ordergroove-offer.js"
    });

    // Initialize the OrderGroove offer component
    var variant = this.iamForm.getCurrentVariant();
    this.onVariantChange({
      variant
    });
  }
  onVariantChange(_ref) {
    var {
      variant
    } = _ref;
    if (!variant) return;
    this.ogOffer.setAttribute('product', variant.id);
    if (!promoConfig.isPromoActive) return;
    var subscriptionDiscount = promoConfig.subscriptionPromoSkus.includes(variant.sku) ? promoConfig.promoDiscountPercent : promoConfig.defaultDiscountPercent;

    // Discount percent label
    var discountLabels = this.ogOffer.querySelectorAll('og-incentive-text[from="DiscountPercent"]');
    discountLabels.forEach(label => {
      label.innerHTML = "".concat(subscriptionDiscount, "%");
    });

    // Subscription price elements
    var subAdjustedPriceElements = this.ogOffer.querySelectorAll('og-price[subscription]');
    subAdjustedPriceElements.forEach(priceEl => {
      var adjustedPrice = document.createElement('span');
      adjustedPrice.slot = 'fallback';
      adjustedPrice.textContent = calculateDiscountedPrice(variant.price, subscriptionDiscount);
      priceEl.replaceChildren(adjustedPrice);
    });
    var originalPriceElements = this.ogOffer.querySelectorAll('og-price:not([subscription])');
    originalPriceElements.forEach(priceEl => {
      var adjustedPrice = document.createElement('span');
      adjustedPrice.slot = 'fallback';
      adjustedPrice.textContent = formatCentsToDollars(variant.price);
      priceEl.replaceChildren(adjustedPrice);
    });

    // Update One time price elements if discount applies to both subscription and one time and the variant is in the promo SKU list
    if (promoConfig.oneTimePromoSkus.includes(variant.sku)) {
      var oneTimeSalePriceElements = this.ogOffer.querySelectorAll('og-price[regular].og-price--one-time');
      oneTimeSalePriceElements.forEach(priceEl => {
        var adjustedPrice = document.createElement('span');
        adjustedPrice.slot = 'fallback';
        adjustedPrice.textContent = calculateDiscountedPrice(variant.price, subscriptionDiscount);
        priceEl.replaceChildren(adjustedPrice);
      });

      // show the original price and discount percent elements when one time is also discounted.
      this.ogOffer.querySelectorAll('.selling-plan__option--one-time .hide').forEach(el => el.classList.remove('hide'));
    }
  }
}
customElements.define('iam-ordergroove-offer', iamOrdergrooveOffer);
export default iamOrdergrooveOffer;